export type TOSContextType = {
    isTOSEnabled: boolean;
    enableTOS: () => void;
    disableTOS: () => void;
};

export const TOSContextDefaultValues: TOSContextType = {
    isTOSEnabled: false,
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    enableTOS: () => {},
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    disableTOS: () => {},
};
